import { NgModule } from '@angular/core';
import {ShoppingInStoreComponent} from './shopping-in-store.component';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from '../auth-guard.service';
import {ShoppingInStoreResolverService} from './shopping-in-store.resolver';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardService],
        resolve: { response: ShoppingInStoreResolverService },
        component: ShoppingInStoreComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ShoppingInStoreRoutingModule { }
